import { useLocation, useNavigate } from 'react-router-dom';
import Chip from '../../../components/Chip';
import { useGetCampaignCreationRequestsById, useResolveCampaignCreationRequest } from '../../../queries/partner';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { ActionButton } from '../../../components/Forms/ActionButton';
import Modal from '../../Submissions/components/Modal';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CreateCampaignRequestDetails = () => {

    const navigate = useNavigate();
    const { state } = useLocation();
    const requestId = state?.requestId;

    const [resolveModalOpen, setResolveModalOpen] = useState(false);

    const { data: ticketData, isLoading } = useGetCampaignCreationRequestsById(requestId);
    const { mutateAsync: resolveRequest, isPending } = useResolveCampaignCreationRequest();

    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm({
        defaultValues: {
            message: '',
        }
    });

    const onSubmit = async (data) => {
        console.log({
            requestId: requestId,
            ...data,
        });
        await resolveRequest({
            requestId: requestId,
            ...data,
        }, {
            onSuccess: (res) => {
                if (res.error) {
                    toast.error('Something went wrong!');
                    return;
                }
                setResolveModalOpen(false);
                toast.success('Campaign creation request resolved!');
                setTimeout(() => {
                    navigate('/requests/create-request');
                }, 2000);
            }
        });
    }

    if (isLoading) {
        return (
            <div className="flex flex-col w-full font-semibold text-base overflow-visible">
                <section className="flex flex-col justify-center px-5 mt-5 py-5 gap-3 w-full bg-white rounded-md shadow-[0px_4px_25px_rgba(94,92,154,0.1)] overflow-visible">
                    <div className='text-center'>Loading...</div>
                </section>
            </div>
        );
    }

    return (
        <div className="flex flex-col w-full font-semibold text-base overflow-visible">
            <section className="flex flex-col justify-center px-5 pt-4 py-9 gap-3 w-full bg-white rounded-md shadow-[0px_4px_25px_rgba(94,92,154,0.1)] overflow-visible">
                <h1 className="text-xl text-primary font-bold">Create New Campaign Request Details</h1>
                <div className="flex flex-col gap-4">
                    <div className="flex gap-1">
                        <label className="font-semibold text-primary">Partner:</label>
                        <p>{ticketData.ngoId ? `NGO: ${ticketData.ngoId.ngoName}` : ticketData.companyId ? `Company: ${ticketData.companyId.companyName}` : '-'}</p>
                    </div>
                    <div className="flex gap-1">
                        <label className="font-semibold text-primary">Campaign:</label>
                        <p>{ticketData.campaignType || '-'}</p>
                    </div>
                    <div className="flex gap-1">
                        <label className="font-semibold text-primary">Landing Page URL:</label>
                        <a href={ticketData.landingPageUrl || '-'} target="_blank" rel="noopener noreferrer" className='underline'>{ticketData.landingPageUrl || '-'}</a>
                    </div>
                    <div className="flex gap-1">
                        <label className="font-semibold text-primary">Status:</label>
                        <Chip value={ticketData?.active ? 'Active' : 'Resolved'} color={ticketData?.active ? 'green' : 'blue'} />
                    </div>
                    <div className="flex gap-1">
                        <label className="font-semibold text-primary">CTA Button Text:</label>
                        <p>{ticketData.ctaButtonText || '-'}</p>
                    </div>
                    <div className="flex gap-1">
                        <label className="font-semibold text-primary">Description:</label>
                        {/* <p dangerouslySetInnerHTML={{ __html: ticketData.message }}></p> */}
                        <p>{ticketData.message || '-'}</p>
                    </div>
                    <div className='flex gap-10'>
                        <div className="flex gap-1">
                            <label className="font-semibold text-primary">Campaign Start Date:</label>
                            <p>{new Date(ticketData.startDate).toLocaleDateString()}</p>
                        </div>
                        <div className="flex gap-1">
                            <label className="font-semibold text-primary">Campaign End Date:</label>
                            <p>{new Date(ticketData.endDate).toLocaleDateString()}</p>
                        </div>
                    </div>
                    {
                        ticketData?.resolvedAt && (
                            <div className="flex gap-1">
                                <label className="font-semibold text-primary">Ticket Resolved Date:</label>
                                <p>{new Date(ticketData.resolvedAt).toLocaleDateString()}</p>
                            </div>
                        )
                    }
                    {ticketData.NGOId && (
                        <div className="flex gap-1">
                            <label className="font-semibold text-primary">NGO Name:</label>
                            <p>{ticketData.NGOId.ngoName}</p>
                        </div>
                    )}
                    {ticketData.companyId && (
                        <div className="flex gap-1">
                            <label className="font-semibold text-primary">Company Name:</label>
                            <p>{ticketData.companyId.companyName}</p>
                        </div>
                    )}
                    <div className='flex flex-col gap-1'>
                        <label className="font-semibold text-primary">Media:</label>
                        {ticketData.image ? (
                            <img
                                src={ticketData.image}
                                alt="Campaign Media"
                                className="w-48 h-48 object-cover rounded cursor-pointer"
                                onClick={() => window.open(ticketData.image, '_blank')}
                            />
                        ) : (
                            <p className="text-base">No media uploaded</p>
                        )}
                    </div>
                    {!ticketData.active && ticketData.resolveComment && (
                        <div className="flex gap-1">
                            <label className="font-semibold text-primary text-nowrap">Resolution Comment:</label>
                            <p>{ticketData.resolveComment}</p>
                        </div>
                    )}
                </div>
                <Modal isOpen={resolveModalOpen} onClose={() => setResolveModalOpen(false)}>
                    <h1>Do you really want to mark as resolved?</h1>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="flex flex-col items-start justify-end gap-1 mt-5">
                            <p>Message</p>
                            <textarea
                                type="number"
                                className="border border-border rounded-md p-2 w-full text-base outline-none focus:outline-none resize-none"
                                rows={7}
                                {...register('message', {
                                    required: 'Message is required.'
                                })}
                            />
                            {
                                errors.message && (
                                    <p className="text-red text-base">{errors.message.message}</p>
                                )
                            }
                        </div>
                        <div className='flex items-center justify-end mt-5'>
                            <ActionButton
                                text="Mark as Resolved"
                                variant={'submit'}
                                disabled={isPending || ticketData?.active === false}
                            />
                        </div>
                    </form>
                </Modal>
                {
                    ticketData?.active && (
                        <div className='flex items-center justify-end mt-2'>
                            <ActionButton
                                text="Mark as Resolved"
                                variant={'submit'}
                                disabled={isPending || ticketData?.active === false}
                                handleSubmit={() => setResolveModalOpen(true)}
                            />
                        </div>
                    )
                }
            </section>
            <ToastContainer
                position="top-right"
            />
        </div>
    );
}

export default CreateCampaignRequestDetails;